import React from "react";
import { CV } from "@api/Models";
import { Header, Experience, Certifications, Education } from "@components/Home";
import { useTranslation } from "react-i18next";

// import { Divider } from "@mui/material";

export default function Home() {
  const { t } = useTranslation();
  const cv: CV = t("cv", { returnObjects: true }) as CV;

  return (
    <div className="container mx-auto px-4 py-8 gap-y-10 max-w-4xl">
      <Header cv={cv} />
      {/* <Divider className="py-100" /> */}
      <Experience jobs={cv.experience} />
      {/* <Divider className="my-100" /> */}
      <Certifications certifications={cv.certifications} />
      <Education study={cv.study} />
    </div>
  );
}
